export enum LayoutConfigEntity {
    Global = 0,
    Shipment = 1,
    Quote = 2,
    Offer = 3,
    Disposition = 4,
    Invoice = 5,
    SupplierGeography = 6,
    ImportResults = 7,
    SGEmailLogs = 8,
    CustomerBilling = 9
}